import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core'

import { CoreService } from '../../../services'

import { Product, OrderItem, Customer, Checkout, File, Currency, Category, Vat } from 'depoto-core/src/entities'
import { debounce } from 'lodash'

import { SchemaUtil, getThumbUrl as imageGetThumbUrl } from 'src/app/utils'
import { ModalContainerComponent } from 'src/app/components/_common/modal-container/modal-container.component'

@Component({
  selector: 'modal-product-search-stats',
  templateUrl: 'modal-product-search-stats.component.html',
  styleUrls: ['modal-product-search-stats.component.scss'],
})
export class ModalProductSearchStatsComponent implements OnInit {
  @ViewChild('modal') public childModal: ModalContainerComponent
  @ViewChild('searchInputInModal') public searchInputInModal: any
  @Input() public checkout: Checkout
  @Input() public customer: Customer
  @Input() currency: Currency
  @Input() currencyDate: string
  @Output() public onProductSelect: EventEmitter<Product> = new EventEmitter()
  searchValue = ''
  products: Product[] = []
  availabilityTypes: string[] = ['all', 'available', 'reservation', 'stock']
  selectedAvailability = 'all'
  selectedCategories: Category[] = []
  pageNumber = 1
  maxPageNumber = 999
  loading = false
  hasSpecialAddOrderItemsRole = false
  isOpen = false
  intersectionObserver = null
  scrollDebounceTimeout = null

  constructor(private core: CoreService) {}

  ngOnInit() {
    this.hasSpecialAddOrderItemsRole = this.core.services.user.hasRole('ROLE_ORDER_SELLITEMS')
  }

  debouncedSearch = debounce(this.updateSearchValue, 500)

  showModalAndFocusOnSearchInput() {
    if (!this.childModal.isShown()) {
      this.childModal.showChildModal()
      setTimeout(() => {
        this.searchInputInModal?.formRow?.nativeElement?.getElementsByTagName('input')?.[0]?.focus()
        this.searchForProduct()
      }, 500) // modal show animation timeout..
    }
  }

  updateSearchValue(val: string) {
    this.searchValue = val
    if (val?.length > 0) {
      this.searchForProduct()
    } else {
      this.childModal.hideChildModal()
    }
  }

  async searchForProduct(addPage?: number) {
    if (addPage) {
      this.pageNumber += addPage
    } else {
      this.pageNumber = 1
    }
    this.loading = true
    const products = await this.core.services.product
      .getList(
        {
          // currency: this.currency?.id,
          // currencyDate: DateUtil.getDateStringFromUTCString(this.currencyDate),
          page: this.pageNumber,
          sort: 'name',
          direction: 'asc',
          filters: {
            fulltext: this.searchValue.trim(),
            listType: 'children_and_parents_without_children',
            // availability: this.selectedAvailability,
            // categories: this.selectedCategories?.length > 0 ? this.selectedCategories?.map(cat => cat.id) : [],
            enabled: true,
          },
        },
        SchemaUtil.productPurchaseOrder,
      )
      .then(result => {
        this.maxPageNumber = result.paginator.endPage
        return result.items.map(p => new Product(p))
      })
    if (this.pageNumber === 1) {
      this.products = products
    } else {
      this.products = [...this.products, ...products]
    }
    this.loading = false
    setTimeout(() => this.initIntersectionObserver(), 300)
  }

  public showChildModal(): void {
    this.searchForProduct()
    this.childModal.showChildModal()
  }

  getThumbUrl(image: File, format: 'w135wp' | 'w2048wp' = 'w135wp'): string {
    return imageGetThumbUrl(image, format)
  }

  updateQuantityFromPacks(product, pack, quantity) {
    pack['quantityTmp'] = Number(quantity)
    product.orderQuantity = product.packs
      .map(p => (p['quantityTmp'] || 0) * p.quantity)
      .reduce((a, b) => Number(a) + Number(b))
  }

  initIntersectionObserver() {
    const el = document.getElementById('next-page-btn')
    if (el) {
      if (this.intersectionObserver) {
        this.intersectionObserver.unobserve(el)
      }
      this.intersectionObserver = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting && !this.loading && !this.scrollDebounceTimeout) {
            this.searchForProduct(1)
            this.scrollDebounceTimeout = setTimeout(() => {
              this.scrollDebounceTimeout = null
            }, 700)
          }
        },
        { threshold: [0] },
      )
      this.intersectionObserver.observe(el)
    }
  }

  chooseProduct(p: Product) {
    this.onProductSelect.emit(p)
    this.childModal.hideChildModal()
    this.searchValue = ''
  }

  isCountByPieces(prod: Product): boolean {
    return prod.tags.some(t => t.externalId === 'hs-count-by-piece')
  }
}
